import * as React from 'react';
import { Grid, Typography } from '@material-ui/core';
import clsx from 'clsx';
import { withStyles, StyledComponentProps } from '@material-ui/core/styles';
import { styles } from '../../styles';
import { reservationRoom } from '../../../../model/reservation';
import moment from 'moment';
import { getDateFromDayCode } from './commonReservation-utilities';
import PrevButton from '../../../../ui-components/Button/PrevButton';
import NextButton from '../../../../ui-components/Button/NextButton';


interface IProps extends StyledComponentProps {
    reservationRoom: reservationRoom;
    viewType: string;
    disabledChangeDay: boolean;
    nextDay: () => void;
    prevDay: () => void;
}


// var days = ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];

const ReservationColumnDayHeader = (props: IProps) => {
    const classes = props.classes;
    let date = getDateFromDayCode(props.reservationRoom.dayCode)
    return (
        <Grid key={"header-"+date.toLocaleDateString("it-IT", { weekday: 'long' })} container style={{ justifyContent: "center", alignItems: "center" }}>
            {props.viewType === "day" && <PrevButton
                disabled={props.disabledChangeDay}
                onClick={() => { props.prevDay() }} />}

            <Grid item className={classes.reservationDayHeader}>
                <Grid container className={classes.reservationDayRows} >
                    <div className={clsx(classes.reservationDayNumber, { [classes.reservationDayToday]: moment(date).isSame(moment(), "day") })}>
                        <Typography className={classes.reservationDayNumberTypography}>{date.getDate()}</Typography>
                    </div>
                </Grid>
                <Grid item xs={12} className={classes.reservationDayRows} >
                    <Typography className={classes.reservationDayNameTypography}>{date.toLocaleDateString("it-IT", { weekday: 'long' })}</Typography>
                </Grid>
            </Grid>

            {props.viewType === "day" && <NextButton
                disabled={props.disabledChangeDay}
                onClick={() => { props.nextDay() }} />}

        </Grid>
    );

};
export default withStyles(styles as any)(ReservationColumnDayHeader)